/**
 * Pure helpers for formatting rent statistics values.
 * No external deps — tested in src/shared/utils/__test__/.
 */

/**
 * Formats a number as BRL currency (R$ X.XXX,XX).
 */
// Renamed from rent-stats-format [Plano 4]: the functions are generic
// number/currency formatters, but the old name carried the vocabulary of
// the module deleted in Fase 7 -- and the file had been orphaned by that
// deletion, imported only by its own test. Reused by the sales KPIs
// rather than inlining a fourth Intl.NumberFormat.
export function formatStatsCurrency(value: number | undefined | null): string {
  return (value ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/**
 * Formats an integer count with thousands separator.
 */
export function formatStatsCount(value: number | undefined | null): string {
  return (value ?? 0).toLocaleString('pt-BR');
}

/**
 * Converts an ISO month string "YYYY-MM" to a short month label.
 * Example: "2026-08" → "ago/26"
 */
export function formatMonthLabel(isoMonth: string): string {
  const [year, month] = isoMonth.split('-');
  const monthNames = [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
    'jul', 'ago', 'set', 'out', 'nov', 'dez',
  ];
  const idx = parseInt(month, 10) - 1;
  const shortYear = year.slice(2);
  return `${monthNames[idx] ?? month}/${shortYear}`;
}
